var React = require('react');

function Marker1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M5 10.5C5 6 8 3 12.5 3S20 6.75 20 10.5c0 2.333-2.176 5.536-6.529 9.61a1.5 1.5 0 01-1.994.05C7.16 16.507 5 13.287 5 10.5zm7.5 1.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","fill":"#335EEA","key":1})]));
}

Marker1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Marker1;

Marker1.default = Marker1;
